import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateRoom',
})
export class TranslateRoomPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.ROOM_TYPES[value]) {
      return this.translateService.instant(this.customTranslationsService.ROOM_TYPES[value]);
    }

    return value;
  }
}
